import { createReducer, on } from '@ngrx/store';
import { palletsActions } from '../actions/pallets.actions';
import { Pallet, PalletDetails, PalletStatus } from '../models';

export interface PalletsState {
    pallets: Pallet[];
    status: PalletStatus;
    page: number;
    hasMore: boolean;
    pallet: PalletDetails | null;
    loaded: boolean | null;
    loading: boolean | null;
    saving: boolean;
}

export const initialState: PalletsState = {
    pallets: [],
    status: 'open',
    page: 0,
    hasMore: false,
    pallet: null,
    loaded: null,
    loading: null,
    saving: false,
};

export const palletsReducer = createReducer(
    initialState,
    // Load list
    on(palletsActions.loadPallets, (state, { status }): PalletsState => ({
        ...state,
        status,
        loading: true,
        loaded: null,
    })),
    on(palletsActions.loadPalletsSuccess, (state, { payload, page, hasMore }): PalletsState => ({
        ...state,
        loading: false,
        loaded: true,
        page,
        hasMore,
        pallets: page === 1 ? payload : [...state.pallets, ...payload.filter((pallet) => !state.pallets.some((item) => item.code === pallet.code))],
    })),
    on(palletsActions.loadPalletsError, (state): PalletsState => ({
        ...state,
        loading: false,
        loaded: false,
    })),
    // Generate
    on(palletsActions.generatePallets, (state): PalletsState => ({
        ...state,
        saving: true,
    })),
    on(palletsActions.generatePalletsSuccess, (state): PalletsState => ({
        ...state,
        saving: false,
    })),
    on(palletsActions.generatePalletsError, (state): PalletsState => ({
        ...state,
        saving: false,
    })),
    // Load one
    on(palletsActions.loadPallet, (state): PalletsState => ({
        ...state,
        pallet: null,
    })),
    on(palletsActions.loadPalletSuccess, (state, { payload }): PalletsState => ({
        ...state,
        pallet: payload,
    })),
    // Add / remove carton
    on(palletsActions.addCarton, palletsActions.removeCarton, (state): PalletsState => ({
        ...state,
        saving: true,
    })),
    on(palletsActions.addCartonSuccess, palletsActions.removeCartonSuccess, (state, { payload }): PalletsState => ({
        ...state,
        saving: false,
        pallet: payload,
    })),
    on(palletsActions.addCartonError, palletsActions.removeCartonError, (state): PalletsState => ({
        ...state,
        saving: false,
    })),
    // Close
    on(palletsActions.closePallet, (state): PalletsState => ({
        ...state,
        saving: true,
    })),
    on(palletsActions.closePalletSuccess, (state, { payload }): PalletsState => ({
        ...state,
        saving: false,
        pallet: payload,
    })),
    on(palletsActions.closePalletError, (state): PalletsState => ({
        ...state,
        saving: false,
    })),
    // Clear
    on(palletsActions.clear, (): PalletsState => ({ ...initialState })),
);
